import React from 'react';

const STATUS_CONFIG = {
  OPEN:     { bg: 'var(--color-bg-active)',      color: 'var(--color-text-muted)' },
  LOADING:  { bg: 'var(--color-indigo-light)',   color: 'var(--color-indigo-dark)' },
  LOADED:   { bg: 'var(--color-accent-light)',   color: 'var(--color-accent-dark)' },
  CLOSED:   { bg: 'var(--color-success-light)',  color: 'var(--color-success-dark)' },
  REOPENED: { bg: 'var(--color-warning-light)',  color: 'var(--color-warning-dark)' },
  AMENDED:  { bg: 'var(--color-warning-light)',  color: 'var(--color-warning-dark)' },
};

export default function BolStatusBadge({ status }) {
  if (!status) return null;
  const key = status.toUpperCase();
  const cfg = STATUS_CONFIG[key] || STATUS_CONFIG.OPEN;
  return (
    <span style={{
      display: 'inline-flex', alignItems: 'center',
      padding: 'var(--space-1) var(--space-4)',
      borderRadius: 'var(--radius-pill)',
      fontSize: 'var(--text-2xs)', fontWeight: 'var(--font-semibold)',
      whiteSpace: 'nowrap', lineHeight: '1.4',
      background: cfg.bg, color: cfg.color,
    }}>
      {key.charAt(0) + key.slice(1).toLowerCase()}
    </span>
  );
}
